// extracted by mini-css-extract-plugin
export var fadeIn = "_l8-1";
export var modalContent = "_l8-3";
export var overlay = "_l8-0";
export var popoverContent = "_l8-2";
export var results = "_l8-5";
export var searchInputWrapper = "_l8-4";